import {
  PagedContent,
  ResultsStatus,
  SelectOption,
  WithContent,
} from '@src/common/types';

export const riskScoresId = 'riskScores';

export interface RiskScoresResultsStore {
  resultStatus: ResultsStatus;
  riskScoreTableData: RiskScoreData[];
  totalElements: number;
  loadingMore: boolean;
  moreToLoad: boolean;
  pageIndex: number;
}

export interface RiskScoresPopoverBreakdownProps {
  signals: RiskSignal[];
  value: number;
}

export interface RiskScoresFilterPanelStore {
  activityRangeOptions: SelectOption[];
  activityRange: string;
  fraudTypeOptions: SelectOption[];
  fraudType: string;
  searchBtnEnabled: boolean;
  loading: boolean;
}

export interface RaFilterPanelState {
  activityRange: string;
  fraudType: string;
}

export interface RiskSignalApiResp {
  name: string;
  weight: number;
  weightAssignedDateTime: string;
  expiryDateTime: string;
  eventIds: string[];
}
export interface RiskSignal extends RiskSignalApiResp {
  id: string;
}

export interface RiskScoreDataApiResp {
  fraudPatternTypeCode: string;
  matchedAccountType: string;
  matchedAccountValue: number;
  riskScore: number;
  lastActivityDateTime: string;
  riskThresholdId: number;
  riskThresholdName: string;
  riskThresholdDescription: string;
  riskScoreTrend: string;
  riskSignals: RiskSignalApiResp[];
}

export interface RiskScoreData extends RiskScoreDataApiResp {
  id: string;
  riskSignals: RiskSignal[];
}

export type RiskScoreSearchApiResponse = WithContent<RiskScoreDataApiResp> &
  PagedContent;

export type RiskScoreSearchResponse = WithContent<RiskScoreData> & PagedContent;

export interface RiskScoreSearchRequest {
  startDate: string;
  endDate: string;
  fraudPatternTypeCode: string;
  pageSize: number;
  pageNumber: number;
}

export interface FraudType {
  code: string;
  displayName: string;
}

export type FraudTypeResponse = WithContent<FraudType>;
